import React from 'react';
import Logo from "../../elements/logo/Logo";
import Nav from './Nav';
import { FiX } from "react-icons/fi";
import {FiTwitter, FiInstagram, FiLinkedin } from "react-icons/fi";
import { FaDiscord } from 'react-icons/fa';

const MobileMenu = ({show, onClose}) => {
    var elements = document.querySelectorAll('.popup-mobile-menu .has-droupdown > a');
    var elementsTwo = document.querySelectorAll('.popup-mobile-menu .with-megamenu > a');
    for(var i in elements) {
        if(elements.hasOwnProperty(i)) {
            elements[i].onclick = function() {
                this.parentElement.querySelector('.submenu').classList.toggle("active");
                this.classList.toggle("open");
            }
        }
    }

    for(var i in elementsTwo) {
        if(elementsTwo.hasOwnProperty(i)) {
            elementsTwo[i].onclick = function() {
                this.parentElement.querySelector('.rn-megamenu').classList.toggle("active");
                this.classList.toggle("open");
            }
        }
    }
    return (
        <div className={`popup-mobile-menu ${show ? "active": ""}`}>
            <div className="inner">
                <div className="header-top">
                    <Logo 
                        image={`${process.env.PUBLIC_URL}/images/logo/Logo_GoodFellazHIGHCompleteWHITE.png`}
                        image2={`${process.env.PUBLIC_URL}/images/logo/Logo_GoodFellazHIGHCompleteWHITE.png`}
                    />
                    <div className="close-menu">
                        <span className="close-button" onClick={onClose}><FiX /></span>
                    </div>
                </div>
                <div>
                    <ul className="mainmenu" onClick={onClose} >
                        <li><a href="#home">HOME</a></li>
                        <li><a href="#about">ABOUT</a></li>
                        <li><a href="#roadmap">ROADMAP</a></li>
                        <li><a href="#utility">UTILITY</a></li>
                        <li><a href="#team">TEAM</a></li>
                        <li><a href="#faq">FAQ</a></li>
                    </ul>
                    <div className="header-right text-center">
                        <ul className="social-icon social-default with-gradient color-lessdark">
                            <li></li>
                            <li><a href="https://discord.gg/goodfellaz"><i className="icon"><FaDiscord size={22}/></i></a></li>
                            <li><a href="https://twitter.com/GoodfellazNFT"><i className="icon"><FiTwitter size={22}/></i></a></li>
                            <li><a href="https://www.instagram.com/goodfellaznft/"><i className="icon"><FiInstagram size={22}/></i></a></li>
                            
                            {/* <li><Link to="linkdin.com"><FiLinkedin /></Link></li> */}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default MobileMenu;